import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./app/auth";
import Appointments from "./app/auth/appointments";
import Claim from "./app/auth/claim";
import IntimateClaim from "./app/auth/claim/intimate_claim";
import NonHealthClaims from "./app/auth/claim/non_health_claims";
import Dashboard from "./app/auth/dashboard";
import Enquiries from "./app/auth/enquiry";
import InnerContent from "./app/auth/inner_content";
import MyProfile from "./app/auth/my_profile";
import Notifications from "./app/auth/notifications/list";
import Policies from "./app/auth/policies";
import PolicyWallet from "./app/auth/policy_wallet";
import AddPolicyWallet from "./app/auth/policy_wallet/add";
import Reviews from "./app/auth/reviews";
import PublicRoutes from "./app/public";
// import ForgotPassword from "./app/public/forgot_pswd";
import Login from "./app/public/login";
import NewPassword from "./app/public/new_password";
import EmailLeadForm from "./app/auth/email_lead_form/update";
import RegistrationPage from "./app/public/registration";
import EmployerDashboard from "./app/auth/employer/employer_dashboard";
import LoginEmployer from "./app/public/login_employer";
import EmployeeList from "./app/auth/list/employees";
import NewVehicle from "./app/auth/new_vehicles";
import PolicyList from "./app/auth/list/policies";
import ClaimList from "./app/auth/list/claims";
import QuoteList from "./app/auth/quotes_list";
import CdBalList from "./app/auth/list/cd_bal";
import TaskPanel from "./app/auth/employer/task_panel";
import PageNotFound from "./app/public/page_not_found";
import EndorsementList from "./app/auth/list/endorsement";
import EmployerQuoteList from "./app/auth/list/quotes";
import EmployerList from "./app/auth/list/employer";
import ContactDetails from "./app/auth/employer/contact_details";
import PolicyForm from "./app/auth/forms/policy_add_edit";
import ClaimForm from "./app/auth/forms/claim_add_edit";
import EndorsementForm from "./app/auth/forms/endorsement_add_edit";
import QuoteFrom from "./app/auth/forms/quote_add_edit";
import NeftDetails from "./app/auth/quotes_list/neft_detail_page";
import PolicyDetails from "./app/auth/forms/policy_view";
import QuoteDetails from "./app/auth/forms/quote_view";
import LoginAdmin from "./app/public/login_admin";
import ForgotPasswordEmployer from "./app/public/forgot_pswd/forgot_pswd_employer";
import ForgotPasswordAdmin from "./app/public/forgot_pswd/forgot_pswd_admin";
import AdminChangePswd from "./app/auth/changePassword/adminChnagePswd";
import EmployerChangePswd from "./app/auth/changePassword/employerChnagePswd";
import OtherQuoteList from "./app/auth/other_quote_list";
import ClaimDetails from "./app/auth/forms/claim_view";
import ThankYou from "./app/public/thankyou";

const MainRoutes = () => {
  return (
    <div className="">
      <Routes>
        <Route path="/" element={<ProtectedRoutes />}>
          <Route path="/" element={<InnerContent />}>
            <Route path="/" element={<Navigate replace to="dashboard" />} />
            <Route path="/employer/dashboard" element={<EmployerDashboard />} />
            <Route path="/employer/list" element={<EmployerList />} />
            <Route path="/employer/employees" element={<EmployeeList />} />
            <Route path="/employer/policies">
              <Route index element={<PolicyList />} />
              <Route path="update" element={<PolicyForm />} />
              <Route path="details" element={<PolicyDetails />} />
            </Route>
            <Route path="/employer/claims">
              <Route index element={<ClaimList />} />
              <Route path="update" element={<ClaimForm />} />
              <Route path="details" element={<ClaimDetails />} />
            </Route>
            {/* <Route path="/employer/claims" element={<ClaimList />} />
            <Route path="/employer/claims-details" element={<ClaimDetails />} />
            reset routes
            <Route path="/employer/claims-update" element={<ClaimForm />} /> */}
            <Route path="/employer/cd-balance" element={<CdBalList />} />
            <Route
              path="/employer/endorsement-update"
              element={<EndorsementForm />}
            />
            <Route path="/employer/endorsments" element={<EndorsementList />} />
            <Route path="/employer/quotes" element={<EmployerQuoteList />} />
            <Route path="employer/quote-update" element={<QuoteFrom />} />
            <Route path="employer/quote-details" element={<QuoteDetails />} />
            {/* <Route path="dashboard" element={<Dashboard />} /> */}
            <Route path="policies" element={<Policies />} />
            <Route path="appointments" element={<Appointments />} />
            <Route path="employer/task-panel" element={<TaskPanel />} />
            <Route
              path="employer/contact-details"
              element={<ContactDetails />}
            />
            <Route path="claim">
              <Route index element={<Claim />} />
              <Route path="intimate-claim" element={<IntimateClaim />} />
              <Route path="non-health-claims" element={<NonHealthClaims />} />
            </Route>
            <Route path="policy-wallet">
              <Route index element={<PolicyWallet />} />
              <Route path="add-policy-wallet" element={<AddPolicyWallet />} />
            </Route>
            <Route path="new-vehicle" element={<NewVehicle />} />
            <Route path="/quotes_list/:policyId" element={<QuoteList />} />
            <Route path="/other_quote_list" element={<OtherQuoteList />} />
            <Route path="/neft_details" element={<NeftDetails />} />
            <Route path="enquiry" element={<Enquiries />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="my-profile" element={<MyProfile />} />
            <Route
              path="/admin-change-password"
              element={<AdminChangePswd />}
            />
            <Route
              path="/employer-change-password"
              element={<EmployerChangePswd />}
            />
            <Route path="reviews" element={<Reviews />} />
            <Route path="verification" element={<EmailLeadForm />} />
            <Route path="*" element={<PageNotFound />} />
          <Route path="/thankyou" element={<ThankYou/>} />
          </Route>
        </Route>
        <Route path="/" element={<PublicRoutes />}>
          <Route path="/login" element={<Login />} />
          <Route path="/employer/login" element={<LoginEmployer />} />
          <Route path="/admin/login" element={<LoginAdmin />} />
          <Route path="/registration" element={<RegistrationPage />} />
          {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
          <Route
            path="/employer-forgot-password"
            element={<ForgotPasswordEmployer />}
          />
          <Route
            path="/admin-forgot-password"
            element={<ForgotPasswordAdmin />}
          />
          <Route
            path="/reset-password/:token/:emailid"
            element={<NewPassword />}
          />
        

          <Route path="*" element={<PageNotFound />} />
           
        </Route>
        
      </Routes>
    </div>
  );
};

export default MainRoutes;
